<template>
    <div class="page">
        <div class="danmu" v-if="choujiang.detail.ifShowDanmu">
            <div class="wrapper">
                <div class="item" v-for="(item, index) in danmu" :key="index">
                    <div
                        class="headImg"
                        :style="
                            `background:url(${require('../../assets/choujiang/' +
                                (index + 1) +
                                '.jpg')}) no-repeat center/cover`
                        "
                    ></div>
                    <div>{{ item.content }}</div>
                </div>
            </div>
        </div>
        <img class="ratio" src="~@/assets/choujiang/ratio.png" alt="" />
        <img class="bg-top2" src="~@/assets/choujiang/bg-top2.png" alt="" />
        <div class="cj-box">
            <div class="num-box" v-if="choujiang.detail.ifShowChance">
                还剩<span>{{ choujiang.chance }}</span
                >次抽奖机会
            </div>
            <div class="box">
                <div class="item active">
                    <div
                        class="top"
                        :style="
                            `background:url(${choujiang.detail.prizeList[0].img}) no-repeat center/cover`
                        "
                    ></div>
                    <div class="bottom">
                        {{ choujiang.detail.prizeList[0].name }}
                    </div>
                </div>
                <div class="item ">
                    <div
                        class="top"
                        :style="
                            `background:url(${choujiang.detail.prizeList[1].img}) no-repeat center/cover`
                        "
                    ></div>
                    <div class="bottom">
                        {{ choujiang.detail.prizeList[1].name }}
                    </div>
                </div>
                <div class="item ">
                    <div
                        class="top"
                        :style="
                            `background:url(${choujiang.detail.prizeList[2].img}) no-repeat center/cover`
                        "
                    ></div>
                    <div class="bottom">
                        {{ choujiang.detail.prizeList[2].name }}
                    </div>
                </div>
                <div class="item ">
                    <div
                        class="top"
                        :style="
                            `background:url(${choujiang.detail.prizeList[7].img}) no-repeat center/cover`
                        "
                    ></div>
                    <div class="bottom">
                        {{ choujiang.detail.prizeList[7].name }}
                    </div>
                </div>
                <div class="start" @click="luckDraw()"></div>
                <div class="item ">
                    <div
                        class="top"
                        :style="
                            `background:url(${choujiang.detail.prizeList[3].img}) no-repeat center/cover`
                        "
                    ></div>
                    <div class="bottom">
                        {{ choujiang.detail.prizeList[3].name }}
                    </div>
                </div>
                <div class="item ">
                    <div
                        class="top"
                        :style="
                            `background:url(${choujiang.detail.prizeList[6].img}) no-repeat center/cover`
                        "
                    ></div>
                    <div class="bottom">
                        {{ choujiang.detail.prizeList[6].name }}
                    </div>
                </div>
                <div class="item ">
                    <div
                        class="top"
                        :style="
                            `background:url(${choujiang.detail.prizeList[5].img}) no-repeat center/cover`
                        "
                    ></div>
                    <div class="bottom">
                        {{ choujiang.detail.prizeList[5].name }}
                    </div>
                </div>
                <div class="item ">
                    <div
                        class="top"
                        :style="
                            `background:url(${choujiang.detail.prizeList[4].img}) no-repeat center/cover`
                        "
                    ></div>
                    <div class="bottom">
                        {{ choujiang.detail.prizeList[4].name }}
                    </div>
                </div>
            </div>
        </div>
        <div
            class="getMoreNum"
            @click="showModal('share')"
            v-if="choujiang.detail.ifShowShare"
        >
            获取更多抽奖机会
        </div>
        <div class="tab-container">
            <div class="tabs">
                <div
                    class="tab"
                    :class="[tabIndex == 0 ? 'active' : '']"
                    @click="changeTabIndex(0)"
                >
                    我的奖品
                </div>
                <div
                    class="tab"
                    :class="[tabIndex == 1 ? 'active' : '']"
                    @click="changeTabIndex(1)"
                    v-if="choujiang.detail.ifShowZhuli"
                >
                    助力记录
                </div>
            </div>
            <div class="container">
                <div
                    class="wrapper"
                    :class="[tabIndex == 0 ? 'left' : 'right']"
                >
                    <div class="tab1-container">
                        <div class="box">
                            <div class="myJiangping">
                                <div
                                    class="item"
                                    v-for="item in myLucky"
                                    :key="item.id"
                                >
                                    <div class="left">
                                        {{ item.name }}
                                    </div>
                                    <div class="right">
                                        <button
                                            class="lingqu"
                                            @click="getPrize(item.id)"
                                            v-if="!item.hasGet"
                                        >
                                            去领取
                                        </button>
                                        <span v-else class="yilingqu">
                                            已领取
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="sub-title">活动规则</div>
                            <div
                                class="intro"
                                v-html="choujiang.detail.rule"
                            ></div>
                        </div>
                    </div>
                    <div
                        class="tab2-container"
                        v-if="choujiang.detail.ifShowZhuli"
                    >
                        <div class="box">
                            <div class="myZhuli">
                                <div
                                    class="item"
                                    v-for="item in myZhuli"
                                    :key="item.id"
                                >
                                    <div class="left">
                                        <div
                                            class="headImg"
                                            :style="
                                                `background:url(${item.headimgurl}) no-repeat center/cover`
                                            "
                                        ></div>
                                        <span>{{ item.nickname }}</span>
                                    </div>
                                    <div class="right">已助力成功</div>
                                </div>
                            </div>
                            <div class="sub-title">活动规则</div>
                            <div
                                class="intro"
                                v-html="choujiang.detail.rule"
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="zz" :class="[showModalName ? 'active' : '']">
            <div class="container">
                <div
                    class="modal zhuli"
                    :class="[showModalName == 'zhuli' ? 'active' : '']"
                >
                    <img
                        class="top"
                        src="~@/assets/choujiang/zhuli-modal.png"
                        alt=""
                    />
                    <img
                        class="title"
                        src="~@/assets/choujiang/zhuli-title.png"
                        alt=""
                    />
                    <div class="content-box">
                        <div class="content">
                            您已为好友助力成功，两人均获得1次抽奖机会！
                        </div>
                        <button class="submit" @click="showModal('')">
                            确认
                        </button>
                    </div>
                </div>

                <div
                    class="modal canyu"
                    :class="[showModalName == 'canyu' ? 'active' : '']"
                >
                    <img
                        class="top"
                        src="~@/assets/choujiang/canyu-modal.png"
                        alt=""
                    />
                    <img
                        class="title"
                        src="~@/assets/choujiang/canyu-title.png"
                        alt=""
                    />
                    <div class="content-box">
                        <div class="content">
                            <div>
                                复制页面链接到微信打开，即可免费获取抽奖机会，100%中奖，还有更多投资干货等你哟~
                            </div>
                            <div>
                                如有疑问，请联系道达号微信客服： Daodahao1997
                            </div>
                            <div class="copyLink" @click="copyUrl()">
                                点击复制连接地址
                            </div>
                            <input type="text" class="hide copyUrl" />
                        </div>
                        <button class="submit" @click="showModal('')">
                            确认
                        </button>
                    </div>
                </div>

                <div
                    class="modal success"
                    :class="[showModalName == 'success' ? 'active' : '']"
                >
                    <img
                        class="top"
                        src="~@/assets/choujiang/success-modal.png"
                        alt=""
                    />
                    <img
                        class="title"
                        src="~@/assets/choujiang/success-title.png"
                        alt=""
                    />
                    <div class="content-box">
                        <div class="content">
                            <div
                                class="img"
                                :style="
                                    `background:url(${lunkTarget.img}) no-repeat center/cover`
                                "
                            ></div>
                            <div class="prize-name">
                                {{ lunkTarget.name }}
                            </div>
                            <div
                                class="notice"
                                v-if="lunkTarget.goodsCode != 'THANKYOU'"
                            >
                                请至道达号赢家学院查询
                            </div>
                        </div>
                        <button
                            v-if="lunkTarget.goodsCode == 'SHIWU'"
                            class="submit"
                            @click="showModal('method')"
                        >
                            去领取
                        </button>
                        <button v-else class="submit" @click="showModal('')">
                            {{ goodsCode == "COUPON" ? "立即使用" : "确定" }}
                        </button>
                    </div>
                </div>

                <div
                    class="modal method "
                    :class="[showModalName == 'method' ? 'active' : '']"
                >
                    <img
                        class="top"
                        src="~@/assets/choujiang/success-modal.png"
                        alt=""
                    />
                    <img
                        class="title"
                        src="~@/assets/choujiang/method-title.png"
                        alt=""
                    />
                    <div class="content-box">
                        <div class="content">
                            <div class="item" @click="changeMethod(0)">
                                <div class="left">邮寄</div>
                                <div
                                    class="right"
                                    :class="[methodType == 0 ? 'active' : '']"
                                >
                                    <img
                                        class="gou"
                                        src="~@/assets/choujiang/gou.png"
                                        alt=""
                                    />
                                    <span>{{
                                        methodType == 0 ? "已选择" : "选择"
                                    }}</span>
                                </div>
                            </div>
                            <div class="item" @click="changeMethod(1)">
                                <div class="left">自提</div>
                                <div
                                    class="right"
                                    :class="[methodType == 1 ? 'active' : '']"
                                >
                                    <img
                                        class="gou"
                                        src="~@/assets/choujiang/gou.png"
                                        alt=""
                                    />
                                    <span>{{
                                        methodType == 1 ? "已选择" : "选择"
                                    }}</span>
                                </div>
                            </div>
                            <div class="intro">
                                <div>
                                    自提地点：四川省成都市锦江区成都报业大厦
                                </div>
                                <div>自提时间：<b>工作日10:00-16:00</b></div>
                                <div class="copyLink" @click="copyAddress()">
                                    点击复制地址
                                </div>
                                <input type="text" class="hide copyAddress" />
                            </div>
                        </div>
                        <button class="submit" @click="goTiqu()">确认</button>
                    </div>
                </div>

                <div
                    class="modal form"
                    :class="[showModalName == 'form' ? 'active' : '']"
                >
                    <img
                        class="top"
                        src="~@/assets/choujiang/success-modal.png"
                        alt=""
                    />
                    <img
                        class="title"
                        src="~@/assets/choujiang/form-title.png"
                        alt=""
                    />
                    <div class="content-box">
                        <div class="content">
                            <div class="form-group">
                                <div class="label">收件人</div>
                                <div class="box">
                                    <input
                                        v-iosInput
                                        type="text"
                                        v-model="user.name"
                                    />
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="label">联系电话</div>
                                <div class="box">
                                    <input
                                        v-iosInput
                                        type="tel"
                                        v-model="user.phone"
                                    />
                                </div>
                            </div>
                            <div class="form-group start">
                                <div class="label">收货地址</div>
                                <div class="box">
                                    <textarea
                                        v-iosInput
                                        v-model="user.address"
                                    ></textarea>
                                </div>
                            </div>
                            <div class="radio-box" @click="changeRadio()">
                                <div
                                    class="radio"
                                    :class="[isRadio ? 'active' : '']"
                                ></div>
                                <div>
                                    填写信息后不可修改，请确认收货信息填写无误
                                </div>
                            </div>
                        </div>
                        <button class="submit" @click="submitForm()">
                            确认
                        </button>
                    </div>
                </div>

                <div
                    class="modal ziti"
                    :class="[showModalName == 'ziti' ? 'active' : '']"
                >
                    <img
                        class="top"
                        src="~@/assets/choujiang/success-modal.png"
                        alt=""
                    />
                    <img
                        class="title"
                        src="~@/assets/choujiang/ziti-title.png"
                        alt=""
                    />
                    <div class="content-box">
                        <div class="content">
                            <div>
                                自提地点：四川省成都市锦江区成都报业大厦3楼
                            </div>
                            <div>
                                自提时间：2020年12月15日-2020年12月31日
                            </div>
                            <div>道达号客服微信号： <br />Daodahao1997</div>
                        </div>
                        <button class="submit" @click="submitZiti()">
                            确认
                        </button>
                    </div>
                </div>

                <div
                    class="modal form-success"
                    :class="[showModalName == 'form-success' ? 'active' : '']"
                >
                    <img
                        class="top"
                        src="~@/assets/choujiang/form-success-modal.png"
                        alt=""
                    />
                    <img
                        class="title"
                        src="~@/assets/choujiang/form-success-title.png"
                        alt=""
                    />
                    <div class="content-box">
                        <div class="content">
                            <div>
                                我们已收到您的物流信息。 Daodahao1997
                            </div>
                            <div>
                                奖品将在信息汇总后统一邮寄
                            </div>
                            <div>
                                如有更多疑问，请联系道达号微信客服：
                                <br />Daodahao1997
                            </div>
                        </div>
                        <button class="submit" @click="showModal('')">
                            确认
                        </button>
                    </div>
                </div>

                <div
                    class="modal qrcode"
                    :class="[showModalName == 'qrcode' ? 'active' : '']"
                >
                    <img
                        class="top"
                        src="~@/assets/choujiang/form-success-modal.png"
                        alt=""
                    />

                    <div class="content-box">
                        <div class="content">
                            <div class="sub-title">如何参与抽奖活动？</div>
                            <div class="desc">
                                长按识别二维码，关注“道达号”微信公众号，即可参与抽奖。
                            </div>
                            <div>
                                <img
                                    class="qrcode"
                                    src="~@/assets/choujiang/qrcode.png"
                                    alt=""
                                />
                            </div>
                        </div>
                        <button class="submit" @click="showModal('')">
                            确认
                        </button>
                    </div>
                </div>

                <div
                    class="modal share"
                    :class="[showModalName == 'share' ? 'active' : '']"
                >
                    <img
                        class="top"
                        src="~@/assets/choujiang/form-success-modal.png"
                        alt=""
                    />

                    <div class="content-box">
                        <div class="content">
                            <div class="sub-title">如何获取更多抽奖机会？</div>
                            <div class="desc">
                                把该链接分享给好友，好友关注，双方都获得一次抽奖机会。
                            </div>
                        </div>
                        <button class="submit" @click="showModal('')">
                            确认
                        </button>
                    </div>
                </div>

                <img
                    class="close"
                    src="~@/assets/choujiang/close.png"
                    @click="showModal('')"
                    alt=""
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { Toast } from "vant";
    import choujiangService from "../../service/choujiang.service";
    import { Choujiang, Goods, User } from "../../types/choujiang.js";
    import danmu from "./danmu";
    export default {
        name: "choujiang",
        data() {
            return {
                danmu: danmu,
                tabIndex: 0,
                disable: false,
                setting: {
                    count: 0,
                    total: 40, // 必须为8的倍数
                    delay: 20,
                    picIndex: [0, 1, 2, 4, 7, 6, 5, 3],
                },
                allItem: [],
                targetIndex: 0,
                showModalName: "",
                methodType: undefined,
                id: "",
                choujiang: new Choujiang(),
                lunkTarget: new Goods(),
                loading: false,
                oldIndex: 0,
                isFirst: true,
                myZhuli: [],
                myLucky: [],
                prizeId: undefined,
                user: new User(),
                isRadio: true,
                goodsCode: "",
                redirect: "",
            };
        },
        created() {
            this.id = this.$route.query.id;
            this.getActivityById(this.isFirst);
            this.getMyZhuli();
            this.getMyLucky();
        },
        mounted() {
            this.allItem = document.querySelectorAll(".cj-box .box .item");
        },
        methods: {
            copyUrl() {
                let inputEl = document.querySelector(".copyUrl");
                inputEl.value = location.href;
                inputEl.select();
                document.execCommand("copy");
                Toast("复制成功");
            },
            copyAddress() {
                let inputEl = document.querySelector(".copyAddress");
                inputEl.value = "四川省成都市锦江区成都报业大厦";
                inputEl.select();
                document.execCommand("copy");
                Toast("复制成功");
            },
            changeRadio() {
                this.isRadio = !this.isRadio;
            },
            getPrize(id) {
                this.prizeId = id;
                this.showModal("method");
            },
            getMyLucky() {
                choujiangService.getMyLucky({ id: this.id }).then((res) => {
                    this.myLucky = res.data;
                });
            },
            getMyZhuli() {
                choujiangService.getMyZhuli({ id: this.id }).then((res) => {
                    this.myZhuli = res.data;
                });
            },
            getActivityById() {
                choujiangService
                    .getActivityById({ id: this.id })
                    .then((res) => {
                        this.choujiang = res.data;
                        if (this.isFirst) {
                            this.isFirst = false;
                            if (!this.choujiang.hasSub) {
                                this.showModal("qrcode");
                            }
                            if (res.data.canzhuli) {
                                let shareCode = this.$route.query.shareCode;
                                if (shareCode) {
                                    this.zhuli(shareCode);
                                }
                            }
                            if (!res.data.isWx) {
                                this.showModal("canyu");
                            }
                        } else {
                            this.getMyLucky();
                        }
                    });
            },
            zhuli(shareCode) {
                choujiangService
                    .zhuli({
                        id: this.id,
                        shareCode,
                    })
                    .then(() => {
                        this.showModal("zhuli");
                    });
            },
            luckDraw() {
                if (this.choujiang.chance <= 0) {
                    if (this.choujiang.detail.ifShowShare) {
                        this.showModal("share");
                    } else {
                        if (this.choujiang.chance <= 0) {
                            let str =
                                this.choujiang.detail.tip ||
                                "对不起您没有抽奖机会了";
                            Toast(str);
                        }
                    }
                    return;
                }
                if (this.loading) {
                    return;
                }
                this.loading = true;
                choujiangService.luckDraw({ id: this.id }).then((res) => {
                    this.targetIndex = res.data.rank - 1;
                    this.lunkTarget = res.data;
                    this.prizeId = res.data.id;
                    this.goodsCode = res.data.goodsCode;
                    this.redirect = res.data.link;
                    this.start();
                });
            },
            changeTabIndex(index) {
                this.tabIndex = index;
            },
            start() {
                let count = this.oldIndex;
                let delay = this.setting.delay;
                let total = this.setting.total;
                if (count > 3) {
                    total += 8;
                }
                if (this.disable) {
                    return;
                }
                this.disable = true;
                total += this.targetIndex;
                let show = () => {
                    for (let i = 0, len = this.allItem.length; i < len; i++) {
                        this.allItem[i].classList.remove("active");
                    }
                    var currentEl = this.allItem[
                        this.setting.picIndex[
                            count % this.setting.picIndex.length
                        ]
                    ];

                    currentEl.classList.add("active");
                    count++;

                    if (count <= Math.ceil(total / 3)) {
                        if (delay < 100) {
                            delay += 1.005 * count + 1;
                        } else {
                            delay = 100;
                        }
                    } else if (count <= Math.ceil((total * 2) / 3)) {
                        delay += 0;
                    } else {
                        delay += 15;
                    }
                    if (count > total) {
                        this.getActivityById();
                        setTimeout(() => {
                            // alert("恭喜中奖了");
                            this.loading = false;
                            this.showModal("success");
                            this.oldIndex = this.targetIndex;
                        }, 500);
                        this.disable = false;
                        return;
                    }
                    setTimeout(show, delay);
                };
                setTimeout(show, delay);
            },
            showModal(name) {
                this.showModalName = name;
                if (!name) {
                    if (this.goodsCode == "COUPON") {
                        this.$router.push(this.redirect);
                    }
                    this.getMyLucky();
                }
            },
            changeMethod(index) {
                this.methodType = index;
            },
            goTiqu() {
                if (this.methodType == 0) {
                    this.showModal("form");
                } else if (this.methodType == 1) {
                    this.showModal("ziti");
                    choujiangService
                        .getPrize({
                            id: this.prizeId,
                            ziti: true,
                        })
                        .then(() => {
                            Toast("领取成功");
                            this.showModal("");
                            this.getMyLucky();
                        });
                } else {
                    Toast("请选择领取方式");
                    return;
                }
            },
            submitForm() {
                if (!this.user.name) {
                    Toast("请填写收件人");
                    return;
                }
                if (!this.user.phone) {
                    Toast("请填写联系电话");
                    return;
                }
                if (!this.user.address) {
                    Toast("请填写收货地址");
                    return;
                }
                if (!this.isRadio) {
                    Toast("请勾选确认信息");
                    return;
                }
                choujiangService
                    .getPrize({
                        id: this.prizeId,
                        ziti: false,
                        ...this.user,
                    })
                    .then(() => {
                        Toast("领取成功");
                        this.showModal("form-success");
                        this.getMyLucky();
                    });
            },
            submitZiti() {
                this.showModal("");
            },
        },
    };
</script>

<style lang="scss" scoped src="./choujiang.scss"></style>
